import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";

const PopupInfo = () => {
  const queryParams = new URLSearchParams(window.location.search);
  //const passedTable = queryParams.get('table') || '';
  const passedTable = queryParams.get("table");
  const isValidTable = passedTable && passedTable.trim() !== "";
  const [showPopup, setShowPopup] = useState(isValidTable);

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    orderType: "dine-in",
    tableNo: passedTable,
  });

  useEffect(() => {
    if (isValidTable) {
      setFormData((prev) => ({ ...prev, tableNo: passedTable }));
      setShowPopup(true);
    }
  }, [isValidTable, passedTable]);

  useEffect(() => {
    const hasTableParam = new URLSearchParams(window.location.search).get(
      "table",
    );
    if (!hasTableParam) {
      localStorage.removeItem("customerInfo");
    }
  }, []);

  const handleChange = (e) => {
    const { id, value, name, type } = e.target;
    const field = type === "radio" ? name : id;
    setFormData((prev) => ({
      ...prev,
      [field]: value,
      ...(field === "orderType" && value === "pickup" ? { tableNo: "" } : {}),
    }));
  };
  const submitInfo = async () => {
    const { name, mobile, orderType, tableNo } = formData;
    if (!showPopup || !tableNo.trim()) return;

    if (!name.trim() || !mobile.trim()) {
      toast.error("Please fill in all required details");
      return;
    }

    localStorage.setItem(
      "customerInfo",
      JSON.stringify({ name, mobile, tableNo }),
    );

    try {
      const res = await fetch("http://localhost:4000/api/infoRoute/save-info", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, mobile, orderType, tableNo }),
      });

      const data = await res.json();
      if (res.ok) {
        toast.success("Thank you!");
        setTimeout(() => {
          setShowPopup(false);
        }, 1000);
      } else {
        toast.error("Error: " + data.error);
      }
    } catch (error) {
      toast.error("Error: " + error.message);
    }
  };

  return showPopup ? (
    <div style={overlayStyle}>
      <div style={popupStyle}>
        <ToastContainer position="top-center" autoClose={500} />

        {/* Header with gradient */}
        <div style={headerContainerStyle}>
          <h3 style={headerStyle}>Enter Your Details</h3>
          <p style={subHeaderStyle}>Join the table and start ordering</p>
        </div>

        <input
          type="text"
          id="name"
          placeholder="Full Name"
          value={formData.name}
          onChange={handleChange}
          style={inputStyle}
        />
        <input
          type="text"
          id="mobile"
          placeholder="Mobile Number"
          value={formData.mobile}
          onChange={handleChange}
          style={inputStyle}
        />

        <div style={radioGroupStyle}>
          <label style={radioLabelStyle}>
            <input
              type="radio"
              name="orderType"
              value="dine-in"
              checked={formData.orderType === "dine-in"}
              onChange={handleChange}
              style={radioInputStyle}
            />
            <span style={radioTextStyle}>Dine In</span>
          </label>
          <label style={radioLabelStyle}>
            <input
              type="radio"
              name="orderType"
              value="pickup"
              checked={formData.orderType === "pickup"}
              onChange={handleChange}
              style={radioInputStyle}
            />
            <span style={radioTextStyle}>Pickup</span>
          </label>
          <label style={radioLabelStyle}>
            <input
              type="radio"
              name="orderType"
              value="delivery"
              checked={formData.orderType === "delivery"}
              onChange={handleChange}
              style={radioInputStyle}
            />
            <span style={radioTextStyle}>Delivery</span>
          </label>
        </div>

        <div style={tableNumberContainerStyle}>
          <label style={tableNumberLabelStyle}>Table No</label>
          <input
            type="text"
            value={formData.tableNo}
            readOnly
            style={tableNumberInputStyle}
          />
        </div>
        <button onClick={submitInfo} style={submitButtonStyle}>
          Submit
        </button>
      </div>
    </div>
  ) : null;
};

const popupStyle = {
  display: "block",
  position: "fixed",
  maxWidth: "450px",
  width: "90%",
  backgroundColor: "white",
  padding: "0",
  border: "none",
  borderRadius: "20px",
  boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
  zIndex: 1000,
  overflow: "hidden",
  textAlign: "center",
};

const headerContainerStyle = {
  background: "linear-gradient(135deg, rgb(var(--brand-500)) 0%, rgb(var(--brand-600)) 100%)",
  padding: "30px 20px",
  marginBottom: "30px",
};

const headerStyle = {
  fontSize: "26px",
  marginBottom: "8px",
  color: "white",
  fontFamily: "Arial, sans-serif",
  fontWeight: "bold",
};

const subHeaderStyle = {
  fontSize: "14px",
  color: "rgba(255, 255, 255, 0.9)",
  margin: 0,
};

const inputStyle = {
  display: "block",
  margin: "12px auto",
  width: "85%",
  padding: "14px 16px",
  border: "2px solid rgb(var(--brand-200))",
  borderRadius: "12px",
  fontSize: "15px",
  transition: "all 0.3s ease",
  outline: "none",
  fontFamily: "Arial, sans-serif",
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999,
  backdropFilter: "blur(4px)",
};

const radioGroupStyle = {
  display: "flex",
  justifyContent: "center",
  gap: "15px",
  marginBottom: "25px",
  padding: "0 20px",
};

const radioLabelStyle = {
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  padding: "8px 16px",
  borderRadius: "8px",
  transition: "background-color 0.2s ease",
  border: "2px solid rgb(var(--brand-200))",
};

const radioTextStyle = {
  fontSize: "14px",
  color: "#1f2937",
  fontWeight: "500",
};

const radioInputStyle = {
  marginRight: "8px",
  cursor: "pointer",
  accentColor: "rgb(var(--brand-500))",
};

const tableNumberContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "30px",
  padding: "0 20px",
};

const tableNumberLabelStyle = {
  marginRight: "12px",
  fontSize: "16px",
  color: "#374151",
  fontWeight: "600",
};

const tableNumberInputStyle = {
  width: "120px",
  padding: "12px 16px",
  border: "2px solid rgb(var(--brand-500))",
  borderRadius: "12px",
  fontSize: "16px",
  fontWeight: "bold",
  textAlign: "center",
  color: "rgb(var(--brand-500))",
  backgroundColor: "rgb(var(--brand-50))",
};

const submitButtonStyle = {
  background: "linear-gradient(135deg, rgb(var(--brand-500)) 0%, rgb(var(--brand-600)) 100%)",
  color: "white",
  padding: "14px 40px",
  border: "none",
  borderRadius: "12px",
  cursor: "pointer",
  fontSize: "16px",
  fontWeight: "bold",
  transition: "all 0.3s ease",
  boxShadow: "0 4px 12px rgba(249, 115, 22, 0.3)",
  marginBottom: "30px",
  width: "85%",
  display: "block",
  margin: "0 auto 30px auto",
};

export default PopupInfo;
